import React, {useContext, useEffect} from 'react'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import './OptionList.scss'
import {IconButton, Checkbox, CircularProgress} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {ReservationConfigurationContext} from '../../context/ReservationConfiguration'
import {useParams} from 'react-router'
import {normalizeFieldValues} from './util'
const RootClass = 'option-list'

const OptionList = ({
  anchorEl,
  data = [],
  values = [],
  field_id,
  open,
  onClose = () => {},
  onChange = (e, values) => {},
}) => {
  const [filtered, setFiltered] = React.useState([])
  const [search, setSearch] = React.useState('')
  const [searchQuery, setSearchQuery] = React.useState('')
  const {group_id} = useParams()

  const {filterValues, getGroupFilterValues} = useContext(ReservationConfigurationContext)

  useEffect(() => {
    if (group_id && field_id && open) {
      getGroupFilterValues({group_id, field_id, query: searchQuery})
    }
  }, [group_id, field_id, searchQuery, getGroupFilterValues, open])

  const handleClick = (e, data) => {
    const _selected = [...values]
    const index = _selected.indexOf(data.value)
    if (index !== -1) {
      _selected.splice(index, 1)
    } else {
      _selected.push(data.value)
    }
    onChange(e, _selected)
  }

  const handleUnselectAll = e => {
    onChange(e, [])
  }

  const handleSearch = e => {
    if ('Enter' === e.key) {
      setSearchQuery(search)
    }
  }

  React.useEffect(() => {
    if (filterValues.data) {
      const _filtered = normalizeFieldValues(filterValues.field_type, filterValues.data)
      setFiltered(_filtered)
    }
  }, [filterValues])

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      className="c-res-mod reservation-limit-reservable__option-popup"
    >
      <div className={`${RootClass}__search-container`}>
        {values.length > 0 && (
          <div className={`${RootClass}__tag`}>
            {values.length}{' '}
            <IconButton
              onClick={handleUnselectAll}
              size="small"
              className={`ap-icon-button ap-icon-button--xs ap-icon-button--white`}
            >
              <CloseIcon />
            </IconButton>
          </div>
        )}
        <TextField
          className={`ap-textfield ${RootClass}__search-field`}
          variant="outlined"
          value={search}
          onChange={e => {
            setSearch(e.target.value)
            if (e.target.value === '') {
              setSearchQuery('')
            }
          }}
          onKeyDown={e => handleSearch(e)}
        />
        <IconButton size="small" className={`${RootClass}__expand-icon`}>
          <ExpandMoreIcon />
        </IconButton>
      </div>
      <div className={`${RootClass}__option-container ap-scrollbar`}>
        {filterValues.isLoading && (
          <CircularProgress className="c-loading-indicator" size={20} color="primary" />
        )}
        {!filterValues.isLoading && filtered.length === 0 && (
          <div style={{padding: 8}} className="ap-typography ap-typography-sm ap-typography--gray">
            No Results Found
          </div>
        )}
        {!filterValues.isLoading &&
          filtered.length > 0 &&
          filtered.map(d => (
            <OptionRow data={d} selected={values.indexOf(d.value) !== -1} onClick={handleClick} />
          ))}
      </div>
    </Popover>
  )
}

const OptionRow = ({data, selected = false, onClick}) => {
  return (
    <div className={`${RootClass}__option-row`} onClick={e => onClick(e, data)}>
      <div className={`${RootClass}__option-cell`} style={{flex: '0 0 42px'}}>
        <Checkbox
          size="small"
          checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
          checked={selected}
        />
      </div>
      <div className={`${RootClass}__option-cell ap-typography ap-typography--sm`}>
        {data.label}
      </div>
    </div>
  )
}

export default OptionList
